import Vue from 'vue';
import axios from 'axios';
import {hasPermission} from "../../utils/permissions";

// initial state
const state = {
    Image: {},
    Images: [],
    TotalPages: 0,
}
// getters
const getters = {

    Image: (state) => {
    return state.Image;
},
    Images: (state) => {
    return state.Images;
},
    TotalPages: (state) => {
    return state.totalPages;
},
}

// mutations
const mutations = {
    SET_IMAGE(state, image) {
        state.Image = image;
    },

    SET_IMAGES(state, images) {
        state.Images = images;
    },
    SET_TOTAL_PAGES(state, TotalPages) {
        state.TotalPages = TotalPages;
    },
    ADD_IMAGE(state, Image) {
        state.Images.push(JSON.parse(JSON.stringify(Image)));
    },
    DELETE_IMAGE(state, index) {
        if (index > -1) {
            state.Images.splice(index, 1);
        }
    },
}

const actions = {
    getAllImages({commit}, [page,limit]) {
        if(hasPermission('media_list')){
            const permission = {
                headers: {
                    'X-Permission': 'media_list'
                }
            };
            return axios.get('/admin/media?limit='+ limit + '&page='+ page,permission).then((response) => {
                let res = response.data;
                commit('SET_IMAGES',res.data)
                let totalPages = Math.ceil(res.total / res.per_page);
                commit('SET_TOTAL_PAGES', totalPages);
                return response.data;
            });
        }

    },
    moreImages({commit}, [page,limit,skipRecord]) {
        if(hasPermission('media_list')){
            const permission = {
                headers: {
                    'X-Permission': 'media_list'
                }
            };
            return axios.get('/admin/media?limit='+ limit + '&page='+ page + '&skipRecord='+ skipRecord,permission).then((response) => {
                let res = response.data;
                for (var i = 0; i < res.data.length; i++) {
                    commit('ADD_IMAGE', res.data[i]);
                }
                return response;
            });
        }

    },
    deleteMedia({commit}, media) {
       var indexes = [];
       var ids = [];
            for (var i = 0; i < media.length; i++) {
                 ids.push(media[i].id);
                 indexes.push(media[i].index);
                commit('DELETE_IMAGE', media[i].index-i);
            }
        if(hasPermission('media_list')){
            const permission = {
                headers: {
                    'X-Permission': 'media_list'
                }
            };
            return axios.post('/admin/media/delete', { ids: ids }, permission).then((response) => {});
        }
    },

    uploadImage ({commit}, media) {
        let formData = new FormData();
        if (typeof media.attachment !== undefined) {
            for (var i = 0; i < media.attachment.length; i++) {
                formData.append("attachment[]", media.attachment[i]);
            }
        }
        if(hasPermission('media_list')){
            const permission = {
                headers: {
                    'X-Permission': 'media_list'
                }
            };
            return axios.post('/admin/media/upload-media/' + media, formData,permission, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then((response) => {
                for (var i = 0; i < response.data.images.length; i++) {
                    commit('ADD_IMAGE',response.data.images[i]);

                }
            });
        }

    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
